/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Actioncomposerheading2Inputs */

const en_actioncomposerheading2 = /** @type {(inputs: Actioncomposerheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New action`)
};

const de_actioncomposerheading2 = /** @type {(inputs: Actioncomposerheading2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Aktion`)
};

/**
* | output |
* | --- |
* | "New action" |
*
* @param {Actioncomposerheading2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const actioncomposerheading2 = /** @type {((inputs?: Actioncomposerheading2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Actioncomposerheading2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_actioncomposerheading2(inputs)
	return de_actioncomposerheading2(inputs)
});
export { actioncomposerheading2 as "actionComposerHeading" }